export default {
    MASCULINO: 'M',
    FEMININO: 'F',
}